import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  BreederRelatedLinksGetBreedersQuery,
  BreederRelatedLinksGetBreedersQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDER_RELATED_LINK_GET_BREEDERS = graphql(`
  query BreederRelatedLinksGetBreeders(
    $take: Int
    $where: DogBreederWhereInput
    $translationsWhere: DogBreederTranslationWhereInput
    $translationsWhereBreed: DogBreedTranslationWhereInput
  ) {
    findManyDogBreeder(where: $where, take: $take, randomOrder: true) {
      id
      translations(where: $translationsWhere) {
        id
        url
      }
      breederBreeds {
        id
        dogBreed {
          id
          translations(where: $translationsWhereBreed) {
            id
            name
          }
        }
      }
    }
  }
`);

export const useGetBreeders = (breedIds?: number[]) => {
  const { language } = useRouter();

  const variables = useMemo((): BreederRelatedLinksGetBreedersQueryVariables => {
    return {
      take: 10,
      translationsWhere: { language: { equals: language } },
      translationsWhereBreed: { language: { equals: language } },
      where: {
        AND: [
          { certified: { equals: true } },
          { public: { equals: true } },
          { breederBreeds: { some: { dogBreedId: { in: breedIds } } } },
          {
            breederBreeds: {
              some: {
                dogBreed: {
                  is: {
                    translations: {
                      some: {
                        AND: [
                          { language: { equals: language } },
                          { url: { not: { equals: '' } } },
                          { url: { not: { equals: undefined } } },
                          { name: { not: { equals: '' } } },
                          { name: { not: { equals: undefined } } },
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    };
  }, [language, breedIds]);

  const { data, error, loading } = useQuery<
    BreederRelatedLinksGetBreedersQuery,
    BreederRelatedLinksGetBreedersQueryVariables
  >(BREEDER_RELATED_LINK_GET_BREEDERS, {
    variables,
    skip: !breedIds?.length,
    ssr: false,
  });

  return {
    breeders: data?.findManyDogBreeder ?? [],
    breedersError: error,
    breedersLoading: loading,
  };
};
